import React from 'react';

import Modal from '../../commonComponents/util/Modal';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import ValidatedPhoneInput from '../../commonComponents/util/ValidatedPhoneInput';
import AddressAutocomplete from '../../commonComponents/shared/AddressAutocomplete';
import NumberFormat from 'react-number-format';
import Select from '../../commonComponents/util/Select';
import RadioGroup from '../../commonComponents/util/RadioGroup';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';

import { deepEquals, isValidEmail, replaceValuesInObject, toTitleCase, validateAddressLocation, validateFieldLength } from '../../../lib/utils';
import { PhoneNumberTypes } from '../../../lib/constants';
import { OrgEmploymentTypes, PreviousEmploymentTypes } from '../../../lib/systemVariables';
import _cloneDeep from 'lodash.clonedeep';

export default class ExternalParticipantModal extends React.Component {
    constructor(props) {
        super(props);

        let state = {
            participant: {
                id: 0,
                personTitleId: '',
                firstName: '',
                lastName: '',
                address: {},
                previousAddress: {},
                teudatZehut: '',
                phoneNumber: '',
                phoneType: this.props.isIsraeli ? PhoneNumberTypes.Israeli : PhoneNumberTypes.American,
                secondPhoneNumber: '',
                secondPhoneType: this.props.isIsraeli ? PhoneNumberTypes.Israeli : PhoneNumberTypes.American,
                email: '',
                bankRoutingNumber: '',
                bankBranchNumber: '',
                bankAccountNumber: '',
                bankAccountHolder: '',
                orgEmploymentType: this.props.isOrgList ? OrgEmploymentTypes.Rebbi : null,
                otherOrgEmployment: "",
                orgEmploymentGrade: "",
                orgEmploymentSeder: "",
                previousEmploymentType: PreviousEmploymentTypes.NA,
                otherPreviousEmployment: '',
                isReceiving: true
            },

            showPrevAddress: false,
            showSecondPhone: false,
            showEmail: false,

            invalidData: {},
            submitAttempted: false
        };

        state.initialParticipant = _cloneDeep(state.participant);
        state.initialState = _cloneDeep(state);

        this.state = state;
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.show && nextProps.show && nextProps.participant.externalListMemberId) { //opening modal for edit
            if (nextProps.participant) {
                this.setParticipantForEdit(nextProps.participant);
            }
        }
    }

    onChangeParticipant = (name, value) => {
        if (name === "firstName" || name === "lastName") {
            value = toTitleCase(value);
        }

        const participant = {
            ...this.state.participant,
            [name]: value
        };

        if (name === 'previousEmploymentType' &&
            (value !== PreviousEmploymentTypes.Other && participant.otherPreviousEmployment)) {
            participant.otherPreviousEmployment = "";
        } else if (name === 'orgEmploymentType') {
            if (value !== OrgEmploymentTypes.Other && participant.otherOrgEmployment) {
                participant.otherOrgEmployment = "";
            } else if (value !== OrgEmploymentTypes.Rebbi && participant.orgEmploymentGrade) {
                participant.orgEmploymentGrade = "";
                participant.orgEmploymentSeder = "";
            }
        } else if (name === 'orgEmploymentGrade' && value < 9 && participant.orgEmploymentSeder) {
            participant.orgEmploymentSeder = "";
        }

        this.setState({ participant });
    }

    onClose = () => {
        this.props.close();
        this.setState(this.state.initialState);
    }

    onSubmit = async () => {
        this.setState({ submitAttempted: true });

        const { invalidData, participant } = this.state;

        if (Object.keys(invalidData).length
            || !participant.firstName || !participant.lastName
            || !participant.address || !participant.address.streetNumber || !participant.address.street || !participant.address.city || !participant.address.country
            || (this.props.isIsraeli &&
                (!participant.teudatZahut || !participant.bankRoutingNumber || !participant.bankBranchNumber || !participant.bankAccountNumber
                ))
            || (this.props.isOrgList && (
                !participant.orgEmploymentType
                || (participant.orgEmploymentType === OrgEmploymentTypes.Other && !participant.otherOrgEmployment)
                || (participant.orgEmploymentType === OrgEmploymentTypes.Rebbi && participant.orgEmploymentGrade === "")
                || (participant.orgEmploymentType === OrgEmploymentTypes.Rebbi && participant.orgEmploymentGrade >= 9 && !participant.orgEmploymentSeder)
            ))
            || (participant.previousEmploymentType === PreviousEmploymentTypes.Other && !participant.otherPreviousEmployment)) {
            return;
        }

        await this.props.submit(participant);

        if (this.props.success) {
            this.onClose();
        }
    }

    setParticipantForEdit = participantForEdit => {
        const formattedParticipant = { ...participantForEdit };
        replaceValuesInObject(formattedParticipant, prop => prop === null, "");

        const participant = {
            ...this.state.participant,
            ...formattedParticipant
        };
        if (this.props.isOrgList && !participant.orgEmploymentType)
            participant.orgEmploymentType = OrgEmploymentTypes.Rebbi;
        if (!participant.previousEmploymentType)
            participant.previousEmploymentType = PreviousEmploymentTypes.NA;

        const hasPrevAddress = participant.previousAddress.streetNumber
            || participant.previousAddress.street
            || participant.previousAddress.city
            || participant.previousAddress.state
            || participant.previousAddress.zip
            || participant.previousAddress.country
            || participant.previousAddress.unitType
            || participant.previousAddress.apartment;

        this.setState({
            ...this.state,
            participant,
            initialParticipant: participant,
            showPrevAddress: hasPrevAddress,
            showSecondPhone: participant.secondPhoneNumber,
            showEmail: participant.email
        });
    }

    updateValidation = (name, value) => {
        let invalidData = { ...this.state.invalidData };
        if (value)
            invalidData[name] = value;
        else
            delete invalidData[name];

        this.setState({ invalidData });
    }

    validateAddress = address => {
        const { locationId, locationGroups } = this.props;

        return validateAddressLocation(locationGroups, locationId, address);
    }

    validateEmail = (name, value) => {
        const isValid = isValidEmail(value);
        this.updateValidation(name, !isValid);
        return isValid;
    }

    validateLength = (name, length, val) => {
        const isValid = validateFieldLength(length, val);
        this.updateValidation(name, !isValid);
        return isValid;
    }

    render() {
        const {
            invalidData,
            initialParticipant,
            participant,
            participant: {
                isReceiving, personTitleId, firstName, lastName,
                address, previousAddress, phoneNumber, phoneType,
                secondPhoneNumber, secondPhoneType, email,
                bankRoutingNumber, bankBranchNumber, bankAccountNumber, bankAccountHolder,
                orgEmploymentType, otherOrgEmployment, orgEmploymentGrade, orgEmploymentSeder,
                previousEmploymentType, otherPreviousEmployment, teudatZahut
            },
            showPrevAddress,
            showSecondPhone,
            showEmail,
            submitAttempted
        } = this.state;
        const {
            isBatched,
            isIsraeli,
            isOrgList,
            loading,
            orgEmploymentTypes,
            previousEmploymentTypes,
            titles,
            show,
            success
        } = this.props;

        return (
            <Modal modalShowing={show}>
                <div className="modal-container">
                    <div className="modal external-participant-modal">
                        <div className="modal-header">
                            <h4 className="page-header">
                                {initialParticipant.externalListMemberId ? `Edit ${initialParticipant.displayName}` : "Add Participant"}
                            </h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
                        </div>
                        {isBatched && <div className="modal-section">
                            <div className="custom-check-container">
                                <input type="checkbox" id="isReceiving" className="custom-check input"
                                    name="isReceiving"
                                    checked={isReceiving}
                                    onChange={e => this.onChangeParticipant(e.target.name, e.target.checked)} />
                                <label htmlFor="isReceiving" className="secondary-text input">Is Receiving</label>
                            </div>
                        </div>}
                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-third mr-8">
                                    <label className="input-label">Title</label>
                                    <Select clearable={true}
                                        options={titles} name="personTitleId" value={personTitleId}
                                        onChange={e => this.onChangeParticipant(e.target.name, e.target.value)} />
                                </div>
                                <div className="column-third mr-8">
                                    <ValidatedInput input={<input type="text" />}
                                        label="First Name" name="firstName" value={firstName}
                                        onChange={this.onChangeParticipant}
                                        required={true} showRequiredError={this.state.submitAttempted} />
                                </div>
                                <div className="column-third">
                                    <ValidatedInput input={<input type="text" />}
                                        label="Last Name" name="lastName" value={lastName}
                                        onChange={this.onChangeParticipant}
                                        required={true} showRequiredError={submitAttempted} />
                                </div>
                            </div>
                            <div className="modal-row info-row">
                                <AddressAutocomplete
                                    address={address}
                                    isIsraeli={isIsraeli}
                                    required={true}
                                    showRequiredError={submitAttempted}
                                    updateAddress={ad => this.onChangeParticipant('address', {
                                        ...address,
                                        ...ad
                                    })}
                                    updateError={val => this.updateValidation('address', val)}
                                    validateAddress={!isOrgList ? this.validateAddress : null}

                                    addAddressLabel={initialParticipant.externalListMemberId
                                        ? ((address.city || address.country || address.state
                                            || address.street || address.streetNumber || address.zip)
                                            && <span
                                                className="link-text small-text"
                                                onClick={() => {
                                                    this.setState({
                                                        participant: {
                                                            ...participant,
                                                            previousAddress: address,
                                                            address: {}
                                                        },
                                                        showPrevAddress: true
                                                    });
                                                }}
                                                title="Set current address to previous"
                                            >Add New Address</span>
                                        )
                                        : (!showPrevAddress
                                            && <span onClick={() => this.setState({ 'showPrevAddress': true })}
                                                className="link-text small-text">Add Previous Address</span>
                                        )}
                                />
                            </div>
                            {showPrevAddress && <div className="modal-row info-row">
                                <AddressAutocomplete
                                    address={previousAddress}
                                    isIsraeli={isIsraeli}
                                    title='Previous Address'
                                    updateAddress={ad => this.onChangeParticipant('previousAddress', {
                                        ...previousAddress,
                                        ...ad
                                    })}
                                    updateError={val => this.updateValidation('previousAddress', val)}
                                    validateAddress={!isOrgList ? this.validateAddress : null}
                                />
                            </div>}
                            <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedPhoneInput
                                        phoneNumber={phoneNumber || ''}
                                        phoneType={phoneType}
                                        phoneNumberName="phoneNumber"
                                        phoneTypeName="phoneType"
                                        onChange={this.onChangeParticipant}
                                        error={invalidData.phone1}
                                        updateError={this.updateValidation}
                                        errorName="phone1"

                                        span1={!showSecondPhone &&
                                            <span onClick={() => this.setState({ showSecondPhone: true })}
                                                className="link-text small-text">Add Phone</span>}
                                        span2={!showEmail &&
                                            <span onClick={() => this.setState({ showEmail: true })}
                                                className="link-text small-text">Add Email</span>}
                                    />
                                </div>
                                {showSecondPhone && <div className="column-half">
                                    <ValidatedPhoneInput
                                        label="Second Phone"
                                        phoneNumber={secondPhoneNumber || ''}
                                        phoneType={secondPhoneType}
                                        phoneNumberName="secondPhoneNumber"
                                        phoneTypeName="secondPhoneType"
                                        onChange={this.onChangeParticipant}
                                        error={invalidData.phone2}
                                        updateError={this.updateValidation}
                                        errorName="phone2" />
                                </div>}
                            </div>
                            {showEmail && <div className="modal-row email-row">
                                <ValidatedInput input={<input type="text" />}
                                    label="Email"
                                    name="email"
                                    value={email}
                                    onChange={this.onChangeParticipant}
                                    validated={true} showValidationError={true}
                                    validate={val => this.validateEmail("email", val)}
                                    errorMessage="Invalid Email Address" />
                            </div>}
                            {isIsraeli && <div>
                                <div className="modal-row">
                                    <div className="column-half">
                                        <ValidatedInput input={<NumberFormat placeholder="##" format="##" />}
                                            label="Bank Number" name="bankRoutingNumber"
                                            value={bankRoutingNumber || ''}
                                            onChange={this.onChangeParticipant}
                                            required={true}
                                            showRequiredError={submitAttempted}
                                            validated={true} showValidationError={true}
                                            validate={val => this.validateLength('bankRoutingNumber', 2, val)}
                                            errorMessage="Invalid Bank Number" />
                                    </div>
                                    <div className="column-half">
                                        <ValidatedInput input={<NumberFormat placeholder="###" format="###" />}
                                            label="Branch Number" name="bankBranchNumber"
                                            value={bankBranchNumber || ''}
                                            onChange={this.onChangeParticipant}
                                            required={true}
                                            showRequiredError={submitAttempted}
                                            validated={true} showValidationError={true}
                                            validate={val => this.validateLength('bankBranchNumber', 3, val)}
                                            errorMessage="Invalid Branch Number" />
                                    </div>
                                </div>
                                <div className="modal-row">
                                    <div className="column-half">
                                        <ValidatedInput input={<NumberFormat placeholder="###############" format="###############" />}
                                            label="Account Number" name="bankAccountNumber"
                                            value={bankAccountNumber || ''}
                                            onChange={this.onChangeParticipant}
                                            required={true} showRequiredError={submitAttempted} />
                                    </div>
                                    <div className="column-half">
                                        <label className="input-label">Account Holder</label>
                                        <input type="text"
                                            name="bankAccountHolder"
                                            value={bankAccountHolder || ''}
                                            onChange={e => this.onChangeParticipant(e.target.name, e.target.value)} />
                                    </div>
                                </div>
                            </div>}
                            {isIsraeli && <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedInput input={<NumberFormat placeholder="#########" format="#########" />}
                                        label="Teudat Zehut" name="teudatZahut" value={teudatZahut} onChange={this.onChangeParticipant}
                                        required={true} showRequiredError={submitAttempted} />
                                </div>
                                <div className="column-half" />
                            </div>}
                            {isOrgList && <div className="modal-row">
                                <div className="column-half">
                                    <RadioGroup
                                        title="Current Position"
                                        name="orgEmploymentType"
                                        value={orgEmploymentType}
                                        options={orgEmploymentTypes}
                                        onChange={this.onChangeParticipant} />
                                </div>
                                <div className="column-half">
                                    {orgEmploymentType === OrgEmploymentTypes.Other &&
                                        <div className="no-margin-bottom-input">
                                            <ValidatedInput
                                                input={<input
                                                    type="text"
                                                    placeholder="Specify"
                                                />}
                                                name="otherOrgEmployment"
                                                value={otherOrgEmployment}
                                                onChange={this.onChangeParticipant}
                                                required={true}
                                                showRequiredError={submitAttempted && !otherOrgEmployment} />
                                        </div>
                                    }
                                    {orgEmploymentType === OrgEmploymentTypes.Rebbi &&
                                        <div className="flex">
                                            <div className="no-margin-bottom-input">
                                                <label htmlFor="" className="input-label">Grade</label>
                                                <ValidatedInput
                                                    input={<Select
                                                        options={[
                                                            { key: 0, value: "Pre-K" },
                                                            { key: 1, value: "1" },
                                                            { key: 2, value: "2" },
                                                            { key: 3, value: "3" },
                                                            { key: 4, value: "4" },
                                                            { key: 5, value: "5" },
                                                            { key: 6, value: "6" },
                                                            { key: 7, value: "7" },
                                                            { key: 8, value: "8" },
                                                            { key: 9, value: "9" },
                                                            { key: 10, value: "10" },
                                                            { key: 11, value: "11" },
                                                            { key: 12, value: "12" }
                                                        ]}
                                                        allowZero={true}
                                                    />}
                                                    name="orgEmploymentGrade"
                                                    value={orgEmploymentGrade}
                                                    onChange={this.onChangeParticipant}
                                                    required={true}
                                                    showRequiredError={submitAttempted && orgEmploymentGrade === ""}
                                                />
                                            </div>

                                            {(orgEmploymentGrade >= 9) &&
                                                <div className="ml-16">
                                                    <RadioGroup
                                                        title="Seder"
                                                        error={submitAttempted && !orgEmploymentSeder}
                                                        name="orgEmploymentSeder"
                                                        value={orgEmploymentSeder}
                                                        options={[
                                                            { key: 1, value: "1st" },
                                                            { key: 2, value: "2nd" }
                                                        ]}
                                                        onChange={this.onChangeParticipant} />
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>}
                            <div className="modal-row">
                                <div className="column-half">
                                    <RadioGroup
                                        title="Prior Position of Employment"
                                        name="previousEmploymentType"
                                        value={previousEmploymentType}
                                        options={previousEmploymentTypes}
                                        onChange={this.onChangeParticipant} />
                                </div>
                                <div className="column-half">
                                    {previousEmploymentType === PreviousEmploymentTypes.Other &&
                                        <div className="no-margin-bottom-input mt-8">
                                            <ValidatedInput
                                                input={<input
                                                    type="text"
                                                    placeholder="Where?"
                                                />}
                                                name="otherPreviousEmployment"
                                                value={otherPreviousEmployment}
                                                onChange={this.onChangeParticipant}
                                                required={true}
                                                showRequiredError={submitAttempted && !otherPreviousEmployment} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        {loading
                            ? <LoadingSpinner height="20" alignRight={true} />
                            : <div className="modal-btns text-right">
                                <button className="btn btn-accent"
                                    onClick={this.onClose}>
                                    Cancel
                                </button>
                                <button className="btn btn-primary"
                                    onClick={this.onSubmit}
                                    disabled={Object.keys(invalidData).length || deepEquals(initialParticipant, participant)}>
                                    {initialParticipant.externalListMemberId ? "Update" : "Submit"}
                                </button>
                                <FadeOutErrorMessage show={!loading && !success} />
                            </div>}
                    </div>
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/campaignComponents/externalLists/ExternalParticipantModal.jsx